import { Box } from "@amzn/awsui-components-console";
import React from "react";
import { PAGE_TITLES, ROUTES } from "src/app/constants";
import { useLocation, Link } from "react-router-dom";
import NavigationBarActions from "./NavigationBarActions";

const ROUTE_TO_TITLE_MAP: { [key: string]: string } = {
  [ROUTES.WC_CLAIM_INTAKE_FORM]: PAGE_TITLES.CLAIM_INTAKE_FORM,
  [ROUTES.MEDICAL_PANEL_DATA]: PAGE_TITLES.MEDICAL_PANEL_DATA,
  [ROUTES.SITE_CONFIGURATION]: PAGE_TITLES.SITE_CONFIGURATION,
  [ROUTES.CLAIMS_HISTORY]: PAGE_TITLES.CLAIMS_HISTORY,
  [ROUTES.WORKERS_COMPENSATION_DOCUMENTS]: PAGE_TITLES.WORKERS_COMPENSATION_DOCUMENTS,
  [ROUTES.DOCUMENTS_MANAGEMENT]: PAGE_TITLES.DOCUMENTS_MANAGEMENT,
  [ROUTES.CARGO_CLAIM_INTAKE_FORM]: PAGE_TITLES.CLAIM_INTAKE_FORM,
  [ROUTES.LANDING_PAGE]: PAGE_TITLES.LANDING_PAGE,
};
const TopNavigationBar = () => {
  const location = useLocation();
  const title = ROUTE_TO_TITLE_MAP[location.pathname || ""] || PAGE_TITLES.CLAIM_INTAKE_FORM;

  return (
    <React.Fragment>
      {/* The app-header id is what AppLayout's headerSelector resolves to
          offset page content, so it has to stay on the rendered header. */}
      <header className="app-header" id="app-header">
        <div className="page-title">
          <Box padding={{ top: "xxs", left: "l" }}>
            <Link to={ROUTES.LANDING_PAGE} className="header-text">
              {title}
            </Link>
          </Box>
        </div>
        <NavigationBarActions />
      </header>
    </React.Fragment>
  );
};
export default TopNavigationBar;
